import { h, setChildren } from "../core/dom.js";
import { api } from "../api.js";
import { navigate } from "../core/router.js";
import { topbar, backLink } from "../components/common.js";
import { spinner, errorState } from "../components/ui.js";
import { weeklyReviewCard } from "../components/weeklyReview.js";
import { weekKey } from "../lib/training.js";

export default function Week({date}={}) {
  const root=h("div",{class:"screen week-screen"});
  const key=date || weekKey();
  const shift=n=>new Date(Date.parse(key)+n*7*86400000).toISOString().slice(0,10);
  async function load(){
    setChildren(root,backLink("Progress","/history"),topbar("Weekly review"),spinner());
    try{
      const review=await api.weeklyReview(key);
      const content=h("div",null,weeklyReviewCard(review,{onSaved:load}));
      const focus=h("select",{id:"review-focus",class:"select",onChange:()=>setChildren(content,weeklyReviewCard({...review,training_goal:focus.value},{onSaved:load}))},
        ...[["general","General fitness"],["strength","Strength"],["hypertrophy","Muscle growth"],["endurance","Endurance"]].map(([value,label])=>h("option",{value,selected:value===(review.training_goal || "general")},label)));
      setChildren(root,backLink("Progress","/history"),topbar("Weekly review",{sub:`${review.week_start} – ${review.week_end} · weeks begin Monday (UTC)`}),
        h("nav",{class:"week-nav","aria-label":"Review week"},
          h("button",{class:"btn btn-ghost",onClick:()=>navigate(`/week/${shift(-1)}`)},"← Previous week"),
          h("button",{class:"btn btn-ghost",disabled:key>=weekKey(),onClick:()=>navigate(`/week/${shift(1)}`)},"Next week →")),
        h("div",{class:"field"},h("label",{for:"review-focus"},"Review focus"),focus),content);
    }catch(e){setChildren(root,topbar("Weekly review"),errorState(e.message,load));}
  }
  load();return root;
}
